import { useTranslation } from "react-i18next";
import { memo, useCallback } from "react";
import {
  TIntegrationRuleIServiceForm,
  integrationRuleIServiceSchema,
} from "./integrationRuleIServiceSchema";
import { FormContainer, Treturn, useFetch } from "@4uhub/lib4uhub";
import { IIntegrationRuleIServiceProps } from "./models";
import {
  createIntegrationRuleIService,
  getIntegrationRuleIServiceById,
  updateIntegrationRuleIServiceById,
} from "../../../../../../../services/integrationRuleIService.service";
import { IntegrationRuleIServiceFields } from "./IntegrationRuleIServiceFields";

const translationPath = "page.4uBus.integrationRule.integrationRuleIService.";

export const IntegrationRuleIService = memo(
  ({
    id,
    busIntegrationRuleId,
    busAutomationCode,
    busAutomationId,
    onBackButton,
  }: IIntegrationRuleIServiceProps) => {
    const { t } = useTranslation();

    const { sendRequest: save, loading: sLoading } = useFetch(
      createIntegrationRuleIService,
    );

    const { sendRequest: update, loading: uLoading } = useFetch(
      updateIntegrationRuleIServiceById,
    );

    const { sendRequest: get, loading: gLoading } = useFetch(
      getIntegrationRuleIServiceById,
    );

    const saveHandler = (v: TIntegrationRuleIServiceForm) =>
      save({
        ...v,
        _4uBusIntegrationRuleId: busIntegrationRuleId ?? "",
        integrationDirectionTypeId: v.integrationDirectionType?.id,
        iServiceId: v.iService?.id,
      });

    const updateHandler = (v: TIntegrationRuleIServiceForm, id: string) =>
      update({
        item: {
          ...v,
          _4uBusIntegrationRuleId: busIntegrationRuleId ?? "",
          integrationDirectionTypeId: v.integrationDirectionType?.id,
          iServiceId: v.iService?.id,
        },
        id: id,
      });

    const getHandler = useCallback(
      async (id: string): Promise<Treturn<TIntegrationRuleIServiceForm>> => {
        const { data, success } = await get(id);
        if (data && success) {
          const newData: TIntegrationRuleIServiceForm = {
            ...data,
          };
          return { data: newData, success: true };
        }

        return { data, success };
      },
      [get],
    );

    const loading = sLoading || uLoading || gLoading;

    return (
      <FormContainer<TIntegrationRuleIServiceForm>
        saveFunction={saveHandler}
        updateFunction={updateHandler}
        getFunction={getHandler}
        loading={loading}
        title={t(translationPath + "integration_rule_i_service")}
        schema={integrationRuleIServiceSchema}
        subtitle={t(translationPath + "new_integration_rule_i_service")}
        backButtonOnClick={onBackButton}
        redirectOnSave={false}
        onSuccess={onBackButton}
        isModalForm={true}
        propId={id}
        formActionsOnBottom={false}
        fields={() => (
          <IntegrationRuleIServiceFields
            busAutomationCode={busAutomationCode}
            busAutomationId={busAutomationId}
          />
        )}
      />
    );
  },
);
